import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { IMenu } from '../../../shared/types/menu.type';

@Component({
  selector: 'sidebar-menu',
  templateUrl: 'sidebar-menu.component.html',
  styleUrls: ['sidebar-menu.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SidebarMenuComponent {
  private route = inject(Router);

  /**
   * Список меню
   */
  @Input() menuList$?: Observable<IMenu[]>;
  /**
   * Состояние свернуто
   */
  @Input() isCollapsed = false;

  isActiveSubmenu(menu: IMenu) {
    return !!menu.submenu?.find((m) => this.route.url.startsWith(`/${m.url}`));
  }
}
